import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { DeviceEnum, PlanTypeEnum, ReferenceTypeEnum } from '../../core';
import { IPlanControl, planErrorMsgs, PlanForm } from '../../models';
import { PlanFormService, UserService } from '../../services';
import { BaseComponent, DeviceLabelPipe, FormValidationMsgDirective, ValidationMessagePipe } from '../../shared';


/**
 * Plan data section component.
 */
@Component({
	selector: 'plan-data',
	templateUrl: './plan-data.component.html',
	imports: [
		AsyncPipe,
		FormsModule,
		UpperCasePipe,
		DeviceLabelPipe,
		NgbCollapseModule,
		ReactiveFormsModule,
		ValidationMessagePipe,
		FormValidationMsgDirective
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PlanDataComponent extends BaseComponent implements OnInit {

	private readonly userSrv = inject(UserService);
	readonly planFormSrv = inject(PlanFormService);

	form?: FormGroup<IPlanControl>;
	isCheckUp = false;
	isReadonly = false;

	isJps = toSignal(this.userSrv.isJps());
	isTlhex = toSignal(this.userSrv.isTlhex());
	isFitbone = toSignal(this.userSrv.isFitbone());
	hasProducts = computed(() => this.isTlhex() || this.isFitbone() || this.isJps());

	readonly deviceEnum = DeviceEnum;
	readonly errorMsgs = planErrorMsgs;
	readonly planTypeEnum = PlanTypeEnum;
	readonly referenceTypeEnum = ReferenceTypeEnum;


	ngOnInit(): void {
		this.planFormSrv.getForm().subscribe(form => {
			this.form = form;
			this.isCheckUp = this.planFormSrv.plan?.isCheckUp ?? false;
			this.isReadonly = this.planFormSrv.isReadonly;
		});
	}

	get formValue(): PlanForm { return this.form?.value as PlanForm; };
	get formCtrl(): IPlanControl | undefined { return this.form?.controls; }

	/**
	* Trim plan id input field.
	*/
	trimPlanId(): void {
		if (this.formValue.planId) {
			this.formCtrl!.planId.setValue(this.formValue.planId.trim());
		}
	}

	/**
	 * Update device additional data.
	 */
	update(): void {
		if (!this.isReadonly && !this.isCheckUp) {
			if (this.formValue.device === this.deviceEnum.Tlhex) {
				this.formCtrl!.postOperative.setValue(null);
				this.formCtrl!.planType.setValue(null);
				this.formCtrl!.referenceType.setValue(null);
			} else {
				this.formCtrl!.postOperative.setValue(false);
				this.formCtrl!.planType.setValue(PlanTypeEnum.Deformity);
				this.formCtrl!.referenceType.setValue(ReferenceTypeEnum.Proximal);
			}
			this.formCtrl!.withImages.setValue(true);
		}
	}

}
